export const shouldOpenDropdownUp = (triggerRect, scrollRect, menuHeight) => {
	if (!triggerRect || !scrollRect) return false
	const spaceBelow = scrollRect.bottom - triggerRect.bottom
	const spaceAbove = triggerRect.top - scrollRect.top
	return spaceBelow < menuHeight && spaceAbove > spaceBelow
}

export const tableDropdownOpensUp = (trigger, menuHeight) => {
	const scrollContainer = trigger?.closest('.column-track-table')
	if (!scrollContainer) return false
	return shouldOpenDropdownUp(
		trigger.getBoundingClientRect(),
		scrollContainer.getBoundingClientRect(),
		menuHeight,
	)
}
